import React from "react";
import classNames from "classnames";
import Icon from "../Icon";
function getBtnContent(actionClass) {
    if (!actionClass) {
        return "";
    } else if (actionClass === "contrast--normal") {
        return "/";
    } else if (actionClass.includes("contrast") || actionClass.includes("font-size")) {
        return "A";
    } else if (actionClass.includes("word-spacing")) {
        switch(actionClass.split("--")[1]){
            case "normal":
                return /*#__PURE__*/ React.createElement(Icon, {
                    name: "text-wordspacing-0",
                    size: "l"
                });
            case "medium":
                return /*#__PURE__*/ React.createElement(Icon, {
                    name: "text-wordspacing-1",
                    size: "l"
                });
            case "large":
                return /*#__PURE__*/ React.createElement(Icon, {
                    name: "text-wordspacing-2",
                    size: "l"
                });
            case "x-large":
                return /*#__PURE__*/ React.createElement(Icon, {
                    name: "text-wordspacing-3",
                    size: "l"
                });
            default:
                return "AB CD";
        }
    } else if (actionClass.includes("letter-spacing")) {
        switch(actionClass.split("--")[1]){
            case "normal":
                return /*#__PURE__*/ React.createElement(Icon, {
                    name: "text-letterspacing-0",
                    size: "l"
                });
            case "medium":
                return /*#__PURE__*/ React.createElement(Icon, {
                    name: "text-letterspacing-1",
                    size: "l"
                });
            case "large":
                return /*#__PURE__*/ React.createElement(Icon, {
                    name: "text-letterspacing-2",
                    size: "l"
                });
            case "x-large":
                return /*#__PURE__*/ React.createElement(Icon, {
                    name: "text-letterspacing-3",
                    size: "l"
                });
            default:
                return "ABCD";
        }
    } else if (actionClass.includes("line-spacing")) {
        switch(actionClass.split("--")[1]){
            case "normal":
                return /*#__PURE__*/ React.createElement(Icon, {
                    name: "text-linespacing-0",
                    size: "l"
                });
            case "medium":
                return /*#__PURE__*/ React.createElement(Icon, {
                    name: "text-linespacing-1",
                    size: "l"
                });
            case "large":
                return /*#__PURE__*/ React.createElement(Icon, {
                    name: "text-linespacing-2",
                    size: "l"
                });
            case "x-large":
                return /*#__PURE__*/ React.createElement(Icon, {
                    name: "text-linespacing-3",
                    size: "l"
                });
            default:
                return "AB CD";
        }
    } else {
        return "";
    }
}
var ClassSwitcher = function(param) {
    var actionClass = param.actionClass, activeClass = param.activeClass, label = param.label, onClick = param.onClick;
    var classes = classNames("app-ally-modal__action", "button__".concat(actionClass), {
        selected: activeClass === actionClass
    });
    return /*#__PURE__*/ React.createElement("button", {
        className: classes,
        "aria-label": label,
        onClick: onClick
    }, getBtnContent(actionClass));
};
export default ClassSwitcher;
